import {
  formatDistance,
  openRingCoords,
  pathLengthMeters,
  polygonAreaMeters
} from './geometry';

/** 更新折线某顶点后重算长度 meta（拖拽时不去重，避免点被合并） */
export function withLineMeta(feature, coordinates) {
  const coords = (coordinates || []).map((c) => [...c]);
  const dist = pathLengthMeters(coords);
  return {
    ...feature,
    coordinates: coords,
    meta: { ...(feature.meta || {}), distance: dist },
    name:
      feature.type === 'measure'
        ? `测距 ${formatDistance(dist)}`
        : feature.name
  };
}

/** 更新区域/矩形顶点后重算面积 */
export function withAreaMeta(feature, coordinates) {
  const ring = openRingCoords(coordinates);
  const area = polygonAreaMeters(ring);
  return {
    ...feature,
    coordinates: ring,
    meta: { ...(feature.meta || {}), area }
  };
}

export function isLineFeatureType(type) {
  return type === 'route' || type === 'measure';
}

export function isAreaFeatureType(type) {
  return type === 'polygon' || type === 'rectangle';
}

export function isSketchFeatureType(type) {
  return type === 'sketch';
}

export function isTextFeatureType(type) {
  return type === 'text';
}

export function isEditableFeatureType(type) {
  return isLineFeatureType(type)
    || isAreaFeatureType(type)
    || isSketchFeatureType(type)
    || isTextFeatureType(type);
}

/** 从编辑快照还原图形 */
export function featureFromEditMeta(editingId, meta) {
  const coords = (meta.coordinates || []).map((p) => [...p]);
  if (isAreaFeatureType(meta.type)) {
    const ring = openRingCoords(coords);
    return {
      id: editingId,
      type: meta.type,
      coordinates: ring,
      color: meta.color,
      opacity: meta.opacity,
      fill: meta.fill !== false,
      name: meta.name,
      meta: { area: polygonAreaMeters(ring) }
    };
  }
  if (isSketchFeatureType(meta.type)) {
    return {
      id: editingId,
      type: 'sketch',
      coordinates: coords,
      color: meta.color,
      opacity: meta.opacity,
      lineWidth: meta.lineWidth || 3,
      fill: false,
      name: meta.name || '手绘',
      meta: {}
    };
  }
  if (isTextFeatureType(meta.type)) {
    return {
      id: editingId,
      type: 'text',
      coordinates: coords.length ? coords : [[0, 0]],
      text: meta.text || '',
      fontFamily: meta.fontFamily,
      fontSize: meta.fontSize,
      letterSpacing: meta.letterSpacing,
      lineHeight: meta.lineHeight,
      color: meta.color,
      bgColor: meta.bgColor,
      bgEnabled: meta.bgEnabled !== false,
      opacity: meta.opacity,
      fill: false,
      name: meta.name || '文字',
      meta: {}
    };
  }
  const dist = pathLengthMeters(coords);
  return {
    id: editingId,
    type: meta.type,
    coordinates: coords,
    color: meta.color,
    opacity: meta.opacity,
    fill: false,
    name: meta.type === 'measure' ? `测距 ${formatDistance(dist)}` : meta.name,
    meta: { distance: dist }
  };
}
